import {
  GET_VIOLATIONS, SEARCH_VIOLATIONS, SEARCH_VIOLATION_FILTERS, SET_VIOLATIONS, GET_COMMENTS, GET_ACTIONS,
  GET_HISTORY, GET_VIOLATION_TERMS, HAS_HISTORY, UPDATE_VIOLATION, SET_SEARCH_RESULTS
} from '../types'
import { trackPromise } from 'react-promise-tracker'
import { getToken } from './auth'
import { parseResponse } from '@jweb-development/response-parser'
import { convertToTimeArray } from '../../utils/functions/actionFunctions'
import log from 'loglevel'
import { loadingAreas } from '../../utils/variables'
// import { setDefaultReportSet } from './select'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

// TODO: [LG-77] add in a parameter or a body to delimit whether we're getting an initial (small) list of data or filling in the rest of the tables
/**
 * Returns an initial list of violations
 * @async
 * @method getViolations
 * @returns List of violations
 */
export const getViolations = (filter, limit = 25, offset = 0, fireFailure = (err = '') => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token, tokenExp, accountId, supervisorID } = getState().auth

      if (!filter.units || !filter.units.length) { filter.units = getState().auth.assignedUnits }
      if (!filter.units || !filter.units.length) { return false }
      if (!limit || offset == null) { return false }

      filter.accountID = accountId
      filter.supervisorID = supervisorID
      filter.limit = limit
      filter.offset = offset

      // provide an array of times for the api to use in the elasticsearch query if startTime and endTime are populated
      const filterTimes = []
      if (filter.startTime && filter.endTime) {
        const tempFilter = convertToTimeArray(filter.startDate, filter.startTime, filter.endDate, filter.endTime)
        filterTimes.push(...tempFilter)
      }

      const body = { filter, filterTimes, supervisorID }

      const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
      if (!authToken) { return false }
      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/violation/list`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const data = await response.json()
        const { captures: dataCaptures = [], flags = [], hits = 0, limitedResults = false } = data

        const captures = dataCaptures.reduce((arr, captureInfo) => {
          if (typeof captureInfo === 'object' && Boolean(captureInfo._source)) {
            arr.push({ ...captureInfo._source, isFlagged: captureInfo.isFlagged || false })
          }

          return arr
        }, [])

        dispatch({
          type: GET_VIOLATIONS,
          payload: { hits, captures, flags, limitedResults }
        })
      } else {
        fireFailure('Failed parsing response!')
      }
    } catch (err) {
      console.error(err)
      fireFailure(err)
    }
  }
}

export const getViolationImageData = (violationInfo, fireSuccess = () => {}, fireFailure = () => {}) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId: accountID } = getState().auth
      const { violationID, fetchOriginal = false } = violationInfo

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/violation/${violationID}/redact${fetchOriginal ? '?fetchOriginal=true' : ''}`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()

        if (data && data.imageData) {
          fireSuccess(data)
          return true
        }
      }
      fireFailure()
      return false
    } catch (err) {
      console.error(err)
      fireFailure()
      return false
    }
  }
}

export const postRedactedQuarantine = (violationInfo, fireSuccess = () => {}, fireFailure = () => {}) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId: accountID, supervisorID } = getState().auth
      const { violationID, redactedImage, s3URL } = violationInfo

      const body = { supervisorID, redactedImage, s3URL }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/violation/${violationID}/redact`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()
        const newUrl = data?.newUrl
        fireSuccess(true, newUrl)
        return true
      }

      fireFailure()
      return false
    } catch (err) {
      console.error(err)
      fireFailure()
      return false
    }
  }
}

export const updateRedactedQuarantine = (violationInfo, fireSuccess = () => {}, fireFailure = () => {}) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId: accountID, supervisorID } = getState().auth
      const { violationID, redactedImage } = violationInfo

      const body = { supervisorID, redactedImage }

      const options = {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/violation/${violationID}/redact`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()
        const newUrl = data?.newUrl
        fireSuccess(true, newUrl)
        return true
      }

      fireFailure()
      return false
    } catch (err) {
      console.error(err)
      fireFailure()
      return false
    }
  }
}

export const getViolationsAsync = async (filter, limit = 25, offset = 0, token, accountId, supervisorID) => {
  try {
    filter.accountID = accountId
    filter.supervisorID = supervisorID
    filter.limit = limit
    filter.offset = offset

    // provide an array of times for the api to use in the elasticsearch query if startTime and endTime are populated
    const filterTimes = []
    if (filter.startTime && filter.endTime) {
      const tempFilter = convertToTimeArray(filter.startDate, filter.startTime, filter.endDate, filter.endTime)
      filterTimes.push(...tempFilter)
    }

    const body = { filter, filterTimes, supervisorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/violation/list`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const data = await response.json()
      if (!data || !data.captures) {
        // error handling block
      }

      let captures = []
      let hits = 0

      captures = data.captures
      hits = data.hits

      const itemsIndex = []
      const items = []
      // use only the relevant data coming from the api
      for (const [index, value] of captures.entries()) {
        itemsIndex.push(index)
        items.push(value._source)
      }
      return {
        captures: items,
        hits: hits || 0,
        flags: data.flags
      }
    } else {
      return false
    }
  } catch (err) {
    console.error(err)
    return false
  }
}

export const updateViolations = (captures) => {
  return async function (dispatch) {
    dispatch({
      type: UPDATE_VIOLATION,
      payload: captures
    })
  }
}

/**
 * Returns a filtered list of violations from ElasticSearch
 * @async
 * @method filterViolations
 * @param {Object} filter Filter params to be used in ES call
 * @returns Array of violations
 */
export const searchViolations = (filter) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID, assignedUnits } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
    filter.accountID = accountId
    filter.units = assignedUnits
    filter.supervisorID = supervisorID

    const body = { filter }
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/violation/search`, options), loadingAreas.SEARCH_VIOLATIONS)
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const data = await response.json()
      dispatch({
        type: SEARCH_VIOLATIONS,
        payload: data
      })
      return true
    }
    return false
  }
}

/**
 * Returns a filtered list of violations from ElasticSearch
 * @async
 * @method filterViolations
 * @param {Object} filter Filter params to be used in ES call
 * @returns Array of violations
 */
export const searchViolationFields = (filter, phrase, type, opts = {}) => {
  return async function (dispatch, getState) {
    const { onSuccess = () => { }, onFailure = () => { } } = opts

    try {
      const { token, tokenExp, accountId, supervisorID, assignedUnits } = getState().auth
      const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
      filter.accountID = accountId
      filter.units = assignedUnits
      if (!filter.units || !filter.units.length) { return false }
      filter.supervisorID = supervisorID
      filter.phrase = phrase
      filter.type = type

      const body = { filter }
      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify(body)
      }

      const response = await window.fetch(`${api}/violation/search/suggestions`, options)
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const data = await response.json()

        if (typeof data === 'object' && Array.isArray(data.suggestions)) {
          dispatch({
            type: SEARCH_VIOLATION_FILTERS,
            payload: { type, suggestions: data.suggestions }
          })

          return onSuccess()
        }
      }

      return onFailure()
    } catch (err) {
      console.log(err)
      return onFailure()
    }
  }
}

/**
* Sets the status of the selected violation
* @async
 * @param {Array} violationIDs id of the violation(s)
 * @param {String} status status of the violation
* @returns boolean with status of request
*/
export const setViolationStatus = (violationIds, status) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
    const body = {
      accountID: accountId,
      violationIDs: violationIds,
      statusFlag: status
    }
    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/violation/status`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      log.debug(response)
      return true
    }
    return false
  }
}

export const setViolations = (violations) => {
  return async function (dispatch) {
    dispatch({
      type: SET_VIOLATIONS,
      payload: {
        captures: violations
      }
    })
  }
}

/**
* Shares the selected violation with a list of users
* @async
 * @param {String} accountId account id of the OU to associate the violation with. Also used for authentication
 * @param {String} violationID id of the violation
 * @param {Array} userIds list of user ids to share the capture with
 * @param {String} comment comment attached to the capture
* @returns boolean with status of request
*/
export const shareViolation = (capture) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
    const body = {
      accountID: accountId,
      ...capture
    }

    // body.accountID = getState().auth.accountId
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/violation/share`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      log.debug(response)
      return true
    }
    return false
  }
}

// /**
// * Adds a comment attached to a capture
// * @async
//  * @param {String} accountId account id of the OU to associate the violation with. Also used for authentication
//  * @param {String} violationID id of the violation
//  * @param {String} comment comment attached to the capture
// * @returns boolean with status of request
// */
// export function postComment (violationId, comment) {
//   return async function (dispatch, getState) {
//     const { token, accountId, supervisorID } = getState().auth
//     const body = {
//       accountID: accountId,
//       violationID: violationId,
//       supervisorID: supervisorID,
//       comment: comment
//     }
//     const options = {
//       method: 'POST',
//       mode: 'cors',
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`
//       },
//       body: JSON.stringify(body)
//     }
//     const response = await trackPromise(window.fetch(`${api}/violation/comment`, options))
//     if (response.status === 401) {
//       dispatch({
//         type: LOGOUT,
//         payload: {
//           message: 'Session expired. Please log in again.',
//           error: true
//         }
//       })
//       return false
//     }
//     const data = await response.json()
//     return true
//   }
// }

export const getHistoryActions = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/actions`, options)

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      dispatch({
        type: GET_ACTIONS,
        payload: data
      })
    } else {
      console.error('Failed to get history actions')
    }
  }
}

export const getHistory = (violationIDs) => {
  return async function (dispatch, getState) {
    dispatch({
      type: HAS_HISTORY,
      payload: false
    })
    const { token, supervisorID, accountId } = getState().auth

    const body = { violationIDs }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/violations/historylist`, options))

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      dispatch({
        type: GET_HISTORY,
        payload: data
      })
      dispatch({
        type: HAS_HISTORY,
        payload: true
      })
    } else {
      console.error('Failed to get history.')
    }
  }
}

export const postHistory = (violationIDs, actionID, actionDetail, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const accountID = accountId

    const body = { actionID, actionDetail, violationIDs }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await window.fetch(`${api}/accounts/${accountID}/supervisors/${supervisorID}/violations/history`, options)

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      fireSuccess(violationIDs)
    } else {
      fireFailure()
    }
  }
}

export const getComments = (violationIDs) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const body = { violationIDs }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/violations/comments`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      dispatch({
        type: GET_COMMENTS,
        payload: data
      })
    } else {
      console.error('Failed to get comments')
    }
  }
}

export const postComment = (violationID, comment, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)

    const body = { comment }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/violations/${violationID}/comments`, options))

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      fireSuccess()
    } else {
      fireFailure()
      // const { data } = await response.json()
    }
  }
}

export const updateComment = (violationID, commentID, newComment, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const body = { newComment }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/violations/${violationID}/comments/${commentID}`, options))

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      log.debug(data)
      fireSuccess()
    } else {
      fireFailure()
    }
  }
}

export const deleteComment = (violationID, commentID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/violations/${violationID}/comments/${commentID}`, options))

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      fireSuccess()
    } else {
      fireFailure()
    }
  }
}

export const getViolationTerms = (violationID) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/violation/${violationID}/terms`, options)
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()
      dispatch({
        type: GET_VIOLATION_TERMS,
        payload: data
      })
    } else {
      console.error('Failed to get violation terms.')
    }
  }
}

export const setFlag = (violations, shouldFlag, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth
    const body = { violations, shouldFlag }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/flag`, options)

    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      fireSuccess()
    } else {
      fireFailure()
    }
  }
}

export const setSearchResults = (searchResults) => {
  return async function (dispatch) {
    dispatch({
      type: SET_SEARCH_RESULTS,
      payload: searchResults
    })
  }
}

export const exportCaptures = (filter, type, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    // const flaggedCaptures = getState().violations.violations.flags
    filter.accountID = accountId
    if (!filter.units || !filter.units.length) { filter.units = getState().auth.assignedUnits }
    if (!filter.units || !filter.units.length) { return fireFailure('You do not currently have units set in your filter. Go to "My Schools" and make sure you have units selected.') }
    filter.supervisorID = supervisorID

    const body = { filter, supervisorID }
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)
    if (!authToken) { return fireFailure('Your credentials are invalid. Please log in again.') }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/export/${type}`, options))
    const parsedResponse = parseResponse(response)
    if (parsedResponse && !parsedResponse.error) {
      // get the base64string data from the response and download it as an attachment
      const { data } = await response.json()
      const link = document.createElement('a')
      link.href = data
      link.download = `report.${type}-${+new Date()}.${type}`
      link.target = '_blank'
      link.click()
      return fireSuccess()
    }
    return fireFailure('There was an error downloading your report. Please try again.')
  }
}

/**
 * make a call to get metadata (all terms, history, and comments) for a group of violations
 * @param {Object} violationConfig - config for getting meta
 * @param {string[]} violationConfig.violationIDs - id's of violations toa cquire meta
 * @param {boolean} violationConfig.
 * @param {*} onSuccess - void
 * @param {*} onFailure - void
 * @returns meta
 */
export const getViolationMeta = (violationConfig, onSuccess = () => { }, onFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { violationIDs = [], includeComments = false, includeHistory = false } = violationConfig
      const { accountId: accountID, supervisorID, token } = getState().auth

      const body = {
        violationIDs,
        includeComments,
        includeHistory,
        supervisorID,
        accountID
      }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/violation/meta`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        // get the base64string data from the response and download it as an attachment
        const { data } = await response.json()
        onSuccess(data)
      } else {
        onFailure(new Error('There was an error getting the capture metadata.'))
      }
    } catch (err) {
      onFailure(new Error('There was an error getting the capture metadata.'))
    }
  }
}
